import { render, staticRenderFns } from "./NodeAnchor.vue?vue&type=template&id=34539bc3&"
import script from "./NodeAnchor.vue?vue&type=script&lang=js&"
export * from "./NodeAnchor.vue?vue&type=script&lang=js&"
import style0 from "./NodeAnchor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports